import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { CityService } from '../../../services';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import {DynamicDialogConfig} from 'primeng/dynamicdialog';

@Component({
  selector: 'app-city-view-modal',
  templateUrl: './city-view-modal.component.html',
  styleUrls: ['./city-view-modal.component.css']
})
export class CityViewModalComponent {

  cityDetail: any;
  idFromParent: number;

  constructor(
    private spinner: NgxSpinnerService,
    private cityService:CityService,
    public ref: DynamicDialogRef, 
    public config: DynamicDialogConfig
  ) 
  {
    this.idFromParent = config.data.id;
  }

  ngOnInit(): void {
    this.getCityDetails();
  }

  getCityDetails()
  {
    this.cityService.getCityDetail(this.idFromParent).subscribe((data: any) => {
      this.cityDetail = data;
      console.log(this.cityDetail);
     });
  }

}
